import React from 'react';

import { cn } from '~ui/lib/utils';

const Input = React.forwardRef(function Input(
  { className, type, ...props },
  ref,
) {
  return (
    <input
      type={type}
      ref={ref}
      className={cn(
        'ui-input flex h-[var(--button-height)] w-full rounded-md border border-solid border-input bg-background px-2.5 text-[length:var(--primary-font-size)] text-foreground transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
});

export { Input };
